import { render, staticRenderFns } from "./PatientHistoryViewDetailsDiagnosis.vue?vue&type=template&id=6d6bef30&scoped=true&lang=pug&"
import script from "./PatientHistoryViewDetailsDiagnosis.vue?vue&type=script&lang=js&"
export * from "./PatientHistoryViewDetailsDiagnosis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6bef30",
  null
  
)

export default component.exports